import api from '../api/axios';
import {
  CandidatoMover,
  FormularioEvaluacion,
  MoverPayload,
  Paso,
  PasoParamsInput,
  PoblarPayload,
  ResultadoPoblado,
} from '../types/paso';

export const pasoService = {
  /** Pasos con su tamaño de comisión y formulario (coordinador). */
  list: async (): Promise<Paso[]> => {
    const { data } = await api.get<Paso[]>('pasos/');
    return data;
  },

  /** Puebla un paso con estudiantes según su regla de ingreso. commit=false → preview. */
  poblar: async (payload: PoblarPayload): Promise<ResultadoPoblado> => {
    const { data } = await api.post<ResultadoPoblado>('coordinacion/poblar/', payload);
    return data;
  },

  /** Procesos de un paso y cohorte, para elegir a quiénes mover a otro paso. */
  candidatosAMover: async (paso: number, ano: number, semestre: number): Promise<CandidatoMover[]> => {
    const { data } = await api.get<CandidatoMover[]>('coordinacion/mover/', { params: { paso, ano, semestre } });
    return data;
  },

  /** Mueve procesos existentes a otro paso. commit=false → preview. */
  mover: async (payload: MoverPayload): Promise<ResultadoPoblado> => {
    const { data } = await api.post<ResultadoPoblado>('coordinacion/mover/', payload);
    return data;
  },

  /** Actualiza los parámetros de comisión de un paso (tamaño, incluir guía/coguía, optimizar áreas). */
  updateParams: async (id: number, input: PasoParamsInput): Promise<Paso> => {
    const { data } = await api.patch<Paso>(`pasos/${id}/`, input);
    return data;
  },

  /** Reemplaza el formulario de evaluación (constructor de preguntas). */
  guardarFormulario: async (id: number, formulario: FormularioEvaluacion): Promise<Paso> => {
    const { data } = await api.put<Paso>(`pasos/${id}/formulario/`, formulario);
    return data;
  },
};
